import React from 'react';

function GuidedPamperingScreen({ addOns, selectedAddOns, onToggleAddOn, parentServiceId, serviceName, onSkip }) {
  const formatPrice = (price) => price > 0 ? `+$${price}` : 'Free';

  return (
    <div className="guided-screen-content">
      <div className="guided-section">
        <div className="guided-card-list">
          {addOns.map(addOn => {
            const isSelected = selectedAddOns.some(s => s.id === addOn.id && s.parentServiceId === parentServiceId);
            return (
              <div
                key={addOn.id}
                className={`guided-card ${isSelected ? 'selected' : ''}`}
                onClick={() => onToggleAddOn(addOn, parentServiceId)}
              >
                <div className="guided-card-left">
                  <div className="guided-card-name">{addOn.name}</div>
                  {addOn.description && <div className="guided-card-desc">{addOn.description}</div>}
                </div>
                <div className="guided-card-right">
                  <div className="guided-card-meta">
                    {addOn.duration > 0 && <div className="guided-card-time">{addOn.duration} Mins</div>}
                    <div className="guided-card-price">{formatPrice(addOn.price)}</div>
                  </div>
                  <div className="guided-card-check">{isSelected ? '✓' : ''}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <button className="guided-no-addons-btn" onClick={onSkip}>
        NO ADD-ONS NEEDED
      </button>
    </div>
  );
}

export default GuidedPamperingScreen;
